module.exports = __webpack_public_path__ + "static/media/po-undercarriage-4.d11b238b.png";